import app from '@/app';
import angular from 'angular';
import templateUrl from './allPlansByRoad-table.html';

/* @ngInject */
function Controller($controller, $httpParamSerializer, DialogService, Principal, Plan) {
	var $ctrl = this;
	$controller('AbstractPageSortController', { $ctrl });

	var transition = $ctrl.transition;
	$ctrl.transition = params => {
		transition(params);
		$ctrl.params = angular.extend({}, params);
    $ctrl.resource = Plan;
		$ctrl.resource.query({"plans": params.plans, "plantype": "DEFAULT"}, data => {
			$ctrl.entities = data.content;
			$ctrl.count = data.totalElements;
		});
	};

  $ctrl.currentAccount = null;

  Principal.identity().then(account => {
	$ctrl.currentAccount = account;
	})

	$ctrl.remove = () =>
		$ctrl.resource.purge($ctrl.params, () => $ctrl.transition($ctrl.params)).$promise;
}

app.component('allPlansByRoadTable', {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^allPlansByRoadSearch'
	},
	bindings: {
		allPlansByRoad: '<',
		$transition$: '<'
	}
});
